import * as React from 'react';

import * as style from './style.css';
import { IBreadcrumb } from '../../../../../offer';

interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ breadcrumbs }) => {
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="Breadcrumbs"
      itemProp="itemListElement"
      itemType="http://schema.org/ListItem"
      itemScope
      className={style['container']}
    >
      {breadcrumbs.map((breadcrumb, index, arr) => {
        return (
          <a
            key={index}
            href={breadcrumb.url}
            title={breadcrumb.title}
            itemProp="url"
            className={style['breadcrumbs-link']}
          >
            <span itemProp="name">{breadcrumb.title}</span>
            {index < arr.length - 1 ? <span className={style['breadcrumbs-delimiter']}>/</span> : null}
          </a>
        );
      })}
    </div>
  );
};
